import RouteManager from './RouteManager'

export const routeManager = new RouteManager()
